
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      solidColors: [
        "#FFFFFF",
        "#C9F5FF",
        "#CBDEFF",
        "#BFB6FF",
        "#D7B6FF",
        "#EFBFDD",
        "#FFCFC1",
        "#FFF6D4",
        "#E2EFC3",
        "#67E2FF",
        "#69A1FF",
        "#6A55FF",
        "#A155FF",
        "#E16CB3",
        "#E1835F",
        "#E1C265",
        "#E1E371",
        "#C0E073",
        "#9B9B9B",
        "#0DD1FF",
        "#0F67FF",
        "#1E00FB",
        "#7000FB",
        "#DD1690",
        "#FF3D05",
        "#FF9E0A",
        "#FFD118",
        "#A4DC1C",
        "#161616",
        "#0042B4",
        "#4800A1",
        "#9C0060",
        "#AC0000",
        "#AF6900"
      ]
      // gradients: [
      //   {
      //     id: "5250de2e-05b3-433c-89ee-51b2437ea955",
      //     fileType: "1",
      //     thumbnail: "2020-5-8/0b13263c-5193-44e6-90ba-5824aef81d8bnail.jpg",
      //     url: "2020-5-8/0b13263c-5193-44e6-90ba-5824aef81d8b.jpg"
      //   },
      //   {
      //     id: "ea3db1bf-6fe9-41f7-8323-ba90e93154a8",
      //     fileType: "1",
      //     thumbnail: "2020-5-8/168ba711-d187-481c-897a-8c06dbb34281.jpg",
      //     url: "2020-5-8/168ba711-d187-481c-897a-8c06dbb34281nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/edf1a5a1-ff68-49d6-b895-331c92da3de8.jpg",
      //     url: "2020-4-28/edf1a5a1-ff68-49d6-b895-331c92da3de8nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/9c7209d2-dfb6-4a69-8649-2722500cbc3b.jpg",
      //     url: "2020-4-28/9c7209d2-dfb6-4a69-8649-2722500cbc3bnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/20fd0fc9-82f9-4197-983c-1730f85a116f.jpg",
      //     url: "2020-4-28/20fd0fc9-82f9-4197-983c-1730f85a116fnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/1b9001d3-33ee-4f6f-8e56-fe67a4ddf2f4.jpg",
      //     url: "2020-4-28/1b9001d3-33ee-4f6f-8e56-fe67a4ddf2f4nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/0c6e5fa9-a622-4e0b-8f7b-f3caaf59879b.jpg",
      //     url: "2020-4-28/0c6e5fa9-a622-4e0b-8f7b-f3caaf59879bnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/f27b6ddb-5dd1-4e76-97f8-1d96559deeb9.jpg",
      //     url: "2020-4-28/f27b6ddb-5dd1-4e76-97f8-1d96559deeb9nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/af43129d-b604-4970-a9cd-d9933d22d5ce.jpg",
      //     url: "2020-4-28/af43129d-b604-4970-a9cd-d9933d22d5cenail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/d7088988-6fa3-47ba-9a23-dc5868c4fa77.jpg",
      //     url: "2020-4-28/d7088988-6fa3-47ba-9a23-dc5868c4fa77nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/4d9024a5-f946-4e9f-b0b6-f398484f2a66.jpg",
      //     url: "2020-4-28/4d9024a5-f946-4e9f-b0b6-f398484f2a66nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/3bc7fbfe-dae8-4159-b9e8-611719ffd9fd.jpg",
      //     url: "2020-4-28/3bc7fbfe-dae8-4159-b9e8-611719ffd9fdnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/fc21936d-0281-4ea7-940d-8d67f7bb8875.jpg",
      //     url: "2020-4-28/fc21936d-0281-4ea7-940d-8d67f7bb8875nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/7161bf47-efe9-4134-9dfb-5845cdd5580e.jpg",
      //     url: "2020-4-28/7161bf47-efe9-4134-9dfb-5845cdd5580enail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/4c2e1dc0-4e86-4f01-8a57-51bd75440ded.jpg",
      //     url: "2020-4-28/4c2e1dc0-4e86-4f01-8a57-51bd75440dednail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/76598082-160c-4373-9e9e-e71e68159c62.jpg",
      //     url: "2020-4-28/76598082-160c-4373-9e9e-e71e68159c62nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/4d6045a9-0e59-4e72-ab43-5b78bbfeb6d4.jpg",
      //     url: "2020-4-28/4d6045a9-0e59-4e72-ab43-5b78bbfeb6d4nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/aa750960-5105-4e0b-8533-b307f30b2927.jpg",
      //     url: "2020-4-28/aa750960-5105-4e0b-8533-b307f30b2927nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/4c285207-4410-405e-9cf2-0a67b40f002d.jpg",
      //     url: "2020-4-28/4c285207-4410-405e-9cf2-0a67b40f002dnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/b8c69b1b-cb3f-4878-9fcc-7d5e03e38405.jpg",
      //     url: "2020-4-28/b8c69b1b-cb3f-4878-9fcc-7d5e03e38405nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/134df951-353b-476e-8f55-55355359099b.jpg",
      //     url: "2020-4-28/134df951-353b-476e-8f55-55355359099bnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/38e5d080-350c-4b86-92c2-15956daeaba5.jpg",
      //     url: "2020-4-28/38e5d080-350c-4b86-92c2-15956daeaba5nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/8f3ce987-299d-4a90-85da-6ab800dc5338.jpg",
      //     url: "2020-4-28/8f3ce987-299d-4a90-85da-6ab800dc5338nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/8269b8eb-3eb8-46f7-888b-fd08f0a5cd86.jpg",
      //     url: "2020-4-28/8269b8eb-3eb8-46f7-888b-fd08f0a5cd86nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/0c01d06e-2019-4f3a-9498-4fc02d17a7dc.jpg",
      //     url: "2020-4-28/0c01d06e-2019-4f3a-9498-4fc02d17a7dcnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/2de270a5-2ebb-4d1b-a5db-0db220f95204.jpg",
      //     url: "2020-4-28/2de270a5-2ebb-4d1b-a5db-0db220f95204nail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/334e4fbe-5601-488c-8503-48b728d48ffd.jpg",
      //     url: "2020-4-28/334e4fbe-5601-488c-8503-48b728d48ffdnail.jpg"
      //   },
      //   {
      //     thumbnail: "2020-4-28/20da5844-862b-4f8a-8ea2-2e6e36176d5c.jpg",
      //     url: "2020-4-28/20da5844-862b-4f8a-8ea2-2e6e36176d5cnail.jpg"
      //   }
      // ]
    };
  },
  props: {},
  components: {},
  methods: {},
  watch: {},
  computed: {}
};
</script>




// WEBPACK FOOTER //
// src/components/mixins/colorsTable.vue